export default [
  {
    title: "Eligibility",
    body: "Refunds are processed for fees paid to HobbsTech Enterprises if a request is made within 30 days of payment, under legitimate circumstances where our service did not meet the agreed-upon standards.",
  },
  {
    title: "Process",
    body: "To request a refund, please contact us with your transaction details and reason for the refund. We aim to process all legitimate refund requests promptly.",
  },
  {
    title: "Contact Us",
    body: "For any questions or concerns about these policies, please contact us at info@hobbstech.co.zw",
  },
];
